import { memo } from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom'; // useLocationを追加

import resets from '../../../_resets.module.css';
import classes from './Button_contact.module.scss';
import { IconMail } from '../../IconMail';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
}
/* @figmaId 269:331 */
export const Button_contact: FC<Props> = memo(function Button_contact(props = {}) {
  const { t } = useTranslation();
  return (
    <Link to={t('common:header.contact_url')} target='_blank' className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.root}`} >
      <div className={classes.buttonText}>{t('common:button.contact-form')}</div>
      <div className={classes.IconMail}>
        <IconMail className={classes.icon} />
      </div>
    </Link>
  );
});

